import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MessageDialogComponent } from '../message-dialog.component';

@Component({
  selector: 'app-help-popup',
  templateUrl: './help-popup.component.html',
  styleUrls: ['./help-popup.component.scss']
})
export class HelpPopupComponent {
  @Input() message: string = 'デフォルトのヘルプメッセージ'; // 親から渡されるメッセージ
  isVisible = false;

  constructor(private dialog: MatDialog) { }

  togglePopup() {
    this.isVisible = !this.isVisible;
  }

  closePopup(event: Event) {
    event.stopPropagation(); // クリックイベントの伝播を防ぐ
    this.isVisible = false;
  }

  openMessage() {
    const dialogRef = this.dialog.open(MessageDialogComponent, {
      width: '400px',
      data: {
        contentHtml: this.message,
        okTitle: '閉じる',
      }
    });
  }

}
